module.exports = __webpack_public_path__ + "static/media/logo_ptm.cffde98c.png";